module.exports = __webpack_public_path__ + "static/media/ic_pa_b4_myway.7196e19b.svg";